import { render, staticRenderFns } from "./CarDeleteButton.vue?vue&type=template&id=bc1b0f20&scoped=true&"
import script from "./CarDeleteButton.vue?vue&type=script&lang=ts&"
export * from "./CarDeleteButton.vue?vue&type=script&lang=ts&"
import style0 from "./CarDeleteButton.vue?vue&type=style&index=0&id=bc1b0f20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1b0f20",
  null
  
)

export default component.exports